module.exports = __webpack_public_path__ + "img/edit-filter.91dd857d.png";